import { BDBBUserRole } from 'src/features/auth/types'
import { User } from 'src/types/schema/graphql'

export const determineInitialRole = (user: User): BDBBUserRole => {
    if (user?.brewlogixSuperadmin) return 'superadmin'
    return 'subscriber'
}
